/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".date-selected[_ngcontent-%COMP%]{color:#ff1493}fieldset[_ngcontent-%COMP%]{margin-bottom:1em}"];
export { styles as styles };
